import { createContext, useContext as useReactContext } from "react";
import { useAppointment } from "../hooks/useAppointment";

const MODAL_DEFAULT_STATE = {
  state: null,
  isOpen: false,
  open: () => {},
  close: () => {},
};

export const Context = createContext({
  id: 0,
  onClose: () => {},
  refetchAppointments: () => {},
  modals: {
    delete: MODAL_DEFAULT_STATE,
  },
});

export const useContext = () => {
  const context = useReactContext(Context);
  const { appointment } = useAppointment(context.id);

  return {
    ...context,
    appointment,
  };
};
